<template>
	<aside
		v-if="displayTopPicks"
		class="top-picks-module-mgr"
		id="lln-toppks"
		:class="{'conmkt':isContMktTab}"
		:data-chronicle="chronicId"
		:data-e2e="ftMmodule"
		data-module-type="link-list"
		:data-metrics-module="ftMmodule"
		v-metric="{ module: ftMmodule }"
	>
		<header>
			<h3>FEATURED</h3>
		</header>
		<ul :class="{twocolumns: twoColumns}">
			<li
				v-for="(item, index) in items"
				:key="item.title"
			>
			<div class="card">
				<div class="container">
					<div class="sponsortoppicks" v-if="item.sponsored">Sponsor Content</div>
					<a
						v-metric="{link: index+1}"
						:href="item.href"
					>
						<span class="link-text"> {{item.text}} </span>
						
					</a>
					<span class="subtext" v-if="!isMobile">{{ item.subtext }}</span>
				</div>
			</div>
			</li>
		</ul>
		<SetRendered
			:chronic-id="chronicId"
			:data="{'items': items, 'moduleData': getModuleByChronicId}"
		/>
	</aside>
</template>

<script>
import useStore from 'webmd-cms-store/src/store';

import _has from 'lodash/has';
import { nextTick } from 'vue';
import SetRendered from './SetRendered.vue';
import ModuleLinks from 'webmd-dynamic-links/index.es6';

export default {
	name: 'TopPicks',
	components: { SetRendered },
	props: {
		chronicId: {
			type: String,
			required: true,
		},
		twoColumns: {
			type: Boolean,
			default: true,
		},
		ftMmodule:{
			type: String,
			default:'lln-toppks',
		},
		linksCount:{
			type: Number,
			default:4,
		}	
	},
	data() {
		return {
			items: [],
			moduleData: {},
			moduleTitle: {},
			isMobile: false,
			displayTopPicks: true,
			ecdQuery: '',
			isContMktTab: false,
		};
	},

	computed: {
		getModuleData() {
			const module = this.getModuleByChronicId;
			return _has(module, 'module_data') ? module.module_data : {};
		},
		getModuleByChronicId() {
			const module = this.store.cms.getModules(this.chronicId);
			return module;
		},
		getModuleTitle() {
			const module = this.moduleData;
			return _has(module, 'module_title') ? module.module_title : '';
		},

		isInfinite() {
			return this.store.flow.isInfinite;
		},

	},
	created() {
		this.store = useStore(this.$pinia);
		this.moduleData = this.getModuleData;
		this.moduleTitle = this.getModuleTitle;
		this.ecdQuery = this.$route?.query?.ecd || '';
	},
	mounted() {
		this.isMobile = window.matchMedia("(max-width: 466px)").matches;
		this.isContMktTab = (document.body.clientWidth > 767 && document.body.clientWidth < 1025) && (this.ecdQuery.includes('conmkt'));

		this.$nextTick(() => {
			// to lazy load
			let moduleId = 18;
			const dlOptions = {
				module: moduleId,
				count: this.linksCount
			};

			const self = this;
			const observer = new IntersectionObserver((entries) => {
				if (entries[0].isIntersecting) {
					ModuleLinks.fill(dlOptions).then((links) => {
						if (links) {	
							self.items = self.parseDynamicData(links);
							observer.unobserve(self.$el);
							if (self.items?.length === 0) {
								this.displayTopPicks = false;
							}
						} else {
							this.displayTopPicks = false;
						}
					});
				}
			},
			{ rootMargin: `0px 0px 1000px 0px` });

			if(self.$el) {
				observer.observe(self.$el);
			}
			
			// to refresh in the future outside of module
			document.addEventListener('webmd.wdl.refresh', async (event) => {
				if (!event.detail || event.detail === moduleId) {
					const links = await ModuleLinks.fill(dlOptions);
					if (links) {
						self.items = self.parseDynamicData(links);
					}
				}
			});
		});
	},

		methods: {
		parseDynamicData(links) {
			return links.map((l) => ({
				text: l.title,
				href: l.url,
				sponsored: l.sponsored,
				subtext: l.teaser,
			}));
		},

	},
};
</script>

<style lang="scss" src="./stylesheets/component.scss">
</style>
